import React from 'react';
import { Link } from 'react-router-dom';
export const Header = () => {
  return <header className="bg-white border-b border-gray-200" data-id="element-60">
      <div className="max-w-4xl mx-auto px-4 py-4 flex justify-between items-center" data-id="element-61">
        <Link to="/" className="font-bold text-2xl text-pink-600" data-id="element-62">
          QISS
        </Link>
        <nav data-id="element-63">
          <ul className="flex space-x-6" data-id="element-64">
            <li data-id="element-65">
              <Link to="/adv" className="text-gray-700 hover:text-pink-600" data-id="element-66">
                Verhaal
              </Link>
            </li>
            <li data-id="element-67">
              <Link to="/pdp" className="text-gray-700 hover:text-pink-600" data-id="element-68">
                Product
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>;
};